<template>
  <div class="mv-main-menu-hide">
    <template v-for="value in this.menus">
      <el-submenu :index="value.resourceUrl ? value.resourceUrl : value.name" v-if="value.childResource.length ? value.childResource : ''" :key="value.id">
        <template slot="title">
          <i class="iconfont" :class="value.icon"></i>
          <span v-on:click="Link(value)" slot="title">{{value.name}}</span>
        </template>
        <Tree :menus="value.childResource"></Tree>
      </el-submenu>
      <el-menu-item :index="value.resourceUrl ? value.resourceUrl : value.name" v-else :key="value.id">
        <i class="iconfont" :class="value.icon"></i>
        <span v-on:click="Link(value)" slot="title">{{value.name}}</span>
      </el-menu-item>
    </template>
    <!-- <el-submenu v-show="item.childResource.length" v-for="(item, index) in menus" :key="index" :index="item.name">
      <template slot="title">
        <i class="el-icon-location"></i>
        <span>{{item.name}}</span>
      </template>
      <el-menu-item v-if="item.childResource.length && !childs.childResource.length" v-for="(childs) in item.childResource"  :key="childs.id" :index="childs.name">
        <span  @click="routeLink(childs)">{{childs.name}}</span>
      </el-menu-item>
      <el-submenu :unique-opened="isCollapse" v-if="item.childResource.length && childs.childResource.length" v-for="(childs) in item.childResource" :index="childs.name" :key="childs.id">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>{{childs.name}}</span>
        </template>
        <el-menu-item  v-for="(children) in childs.childResource" :key="children.id" :index="children.name">{{children.name}}</el-menu-item>
      </el-submenu>
    </el-submenu> -->
  </div>
</template>
<script>
export default {
  props: ['menus'],
  name: 'Tree',
  methods: {
    Link (value) {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/tree/index.vue